module.exports = require('./helpers/bundle-url').getBundleURL('2lNV8') + "declined.3b3c1c53.png";